// extracted by mini-css-extract-plugin
export default {"wrapper":"Step10processing_wrapper__w-Bil","list":"Step10processing_list__8juHu","errorTitle":"Step10processing_errorTitle__wkA8Z"};